var _rect, _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgTv(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 26,
    height: 26,
    viewBox: "0 0 26 26",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 26,
    height: 26,
    rx: 13,
    fill: "#4F66AA"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M7.4 9.15V15.45H18.6V9.15H7.4ZM6 9.15C6 8.37781 6.62781 7.75 7.4 7.75H18.6C19.3722 7.75 20 8.37781 20 9.15V15.45C20 16.2222 19.3722 16.85 18.6 16.85H7.4C6.62781 16.85 6 16.2222 6 15.45V9.15ZM8.8 17.55H17.2C17.5872 17.55 17.9 17.8628 17.9 18.25C17.9 18.6372 17.5872 18.95 17.2 18.95H8.8C8.41281 18.95 8.1 18.6372 8.1 18.25C8.1 17.8628 8.41281 17.55 8.8 17.55Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTv);
export default __webpack_public_path__ + "static/media/tv.af5d6ce156fc9cdc6049ac18f943a647.svg";
export { ForwardRef as ReactComponent };